<template>
  <el-dialog
    id="reactivationDialog"
    v-model="showDialog"
    :before-close="hideDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :width="dialogWidth"
  >
    <WelcomeEligible
      v-show="isCorrectStep(welcomeStep)"
      @click-reactivate="startActivationProcess"
    />
    <WelcomeIneligible v-show="isCorrectStep(ineligibleStep)" />
    <ChannelSelection
      v-if="isCorrectStep(channelSelectionStep)"
      @click-next="goTo(confirmAddressStep)"
      @request-close="setShowDialog(false)"
    />
    <ConfirmAddress
      v-if="isCorrectStep(confirmAddressStep)"
      @click-back="startActivationProcess"
      @click-next="goTo(depositStep)"
    />
    <ReactivationDepositStep
      v-if="isCorrectStep(depositStep)"
      @click-back="goTo(confirmAddressStep)"
      @card-needed="goTo(addCardStep)"
      @reactivation-attempted="verifyReactivation"
    />
    <AddPaymentMethod
      v-if="isCorrectStep(addCardStep)"
      :client-id="clientId"
      @close="goTo(depositStep)"
    />
    <ReactivationComplete
      v-show="isCorrectStep(successStep)"
      @click-finish="completeReactivation"
    />
    <ReactivationFailed
      v-show="isCorrectStep(failureStep)"
      @retry-requested="startActivationProcess"
    />
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import WelcomeEligible from './steps/WelcomeEligible.vue';
import WelcomeIneligible from './steps/WelcomeIneligible.vue';
import ChannelSelection from './steps/ChannelSelection.vue';
import ConfirmAddress from './steps/ConfirmAddress.vue';
import ReactivationComplete from './steps/ReactivationComplete.vue';
import ReactivationDepositStep from './steps/ReactivationDepositStep.vue';
import ReactivationFailed from './steps/ReactivationFailed.vue';
import AddPaymentMethod from './steps/AddPaymentMethod.vue';

export default {
  name: 'Reactivation',
  components: {
    WelcomeEligible,
    WelcomeIneligible,
    ChannelSelection,
    ConfirmAddress,
    ReactivationDepositStep,
    ReactivationComplete,
    ReactivationFailed,
    AddPaymentMethod,
  },
  data: () => ({
    currentStep: 'welcome',
    welcomeStep: 'welcome',
    ineligibleStep: 'ineligible',
    channelSelectionStep: 'channelSelection',
    confirmAddressStep: 'confirmAddress',
    depositStep: 'payment',
    addCardStep: 'addCard',
    successStep: 'success',
    failureStep: 'failure',
    isFetchingPaymentInfo: false,
    isFetchingAccountDetails: false,
  }),
  computed: {
    ...mapGetters('client', ['clientId', 'isEligibleForReactivation']),
    ...mapGetters('reactivation', ['showDialog', 'hasBeenReactivated']),
    ...mapGetters('responsive', ['isXS', 'isMD']),

    dialogWidth() {
      if (this.isXS) {
        return '100%';
      }
      if (this.isMD) {
        return '75%';
      }
      return '50%';
    },
    isCorrectStep() {
      return desiredStep => desiredStep === this.currentStep;
    },
  },
  watch: {
    showDialog(show) {
      if (show) {
        this.updatePaymentInfo();
        this.updateAccountDetails();
      }
    },
  },
  async mounted() {
    this.currentStep = this.isEligibleForReactivation ? this.welcomeStep : this.ineligibleStep;

    await Promise.all([this.updatePaymentInfo(), this.updateAccountDetails()]);
  },
  methods: {
    ...mapActions('client', ['getClientAccountDetails']),
    ...mapActions('reactivation', ['setShowDialog', 'getReactivationPaymentInfoAsync']),

    async updatePaymentInfo() {
      if (this.isFetchingPaymentInfo) {
        return;
      }

      this.isFetchingPaymentInfo = true;

      await this.getReactivationPaymentInfoAsync(this.clientId).finally(() => {
        this.isFetchingPaymentInfo = false;
      });
    },
    async updateAccountDetails() {
      if (this.isFetchingAccountDetails) {
        return;
      }

      this.isFetchingAccountDetails = true;

      await this.getClientAccountDetails({ clientId: this.clientId }).finally(() => {
        this.isFetchingAccountDetails = false;
      });
    },
    hideDialog() {
      this.setShowDialog(false);
      if (this.hasBeenReactivated) {
        this.$router.go();
      }
    },
    goTo(step) {
      this.currentStep = step;
    },
    startActivationProcess() {
      this.goTo(this.channelSelectionStep);
    },
    verifyReactivation() {
      this.currentStep = this.hasBeenReactivated ? this.successStep : this.failureStep;
    },
    completeReactivation() {
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped></style>
